import styles from './Leaderboard.module.css'
import LeaderboardHeader from "./LeaderboardHeader/LeaderboardHeader.tsx";
import BalanceTop from "../../components/BalanceTop/BalanceTop.tsx";
import LeaderboardInfo from "./LeaderboardInfo/LeaderboardInfo.tsx";
import Leaderboard from "./LeaderBoard/Leaderboard.tsx";
import type {LeaderboardData} from "./types/leaderboard.ts";
import {useEffect, useState} from "react";
import {getLeaderboard} from "../../Requests/leaderboard/leaderboard.ts";
import Loader from "../../components/Loader/Loader.tsx";
import type {WebApp} from "../../types/telegram";

interface ExtendedWebApp extends WebApp {
    contentSafeAreaInset?: {
        top: number;
        bottom: number;
        left: number;
        right: number;
    };
}

const LeaderboardPage = () => {

    const [leaderboardData, setLeaderboardData] = useState<LeaderboardData>()

    useEffect(() => {
        const tg = window.Telegram?.WebApp as ExtendedWebApp;
        if (!tg) return;

        console.log(window.Telegram?.WebApp.initData)

        const apply = () => {
            const top = tg?.contentSafeAreaInset?.top ?? 0;
            document.documentElement.style.setProperty(
                '--tg-viewport-content-safe-area-inset-top',
                `${top}px`,
            );
        };

        apply();
        tg.onEvent?.('contentSafeAreaChanged', apply);
        return () => tg.offEvent?.('contentSafeAreaChanged', apply);
    }, []);

    useEffect(() => {
        (async () => {
            const initData = window.Telegram?.WebApp.initData
            if (initData) {
                const data = await getLeaderboard(initData)

                setLeaderboardData(data)
            }
        })()
    }, [])

    return (
        <div className={styles.container}>
            <LeaderboardHeader/>
            <BalanceTop/>
            <LeaderboardInfo/>
            {leaderboardData ? <Leaderboard data={leaderboardData} /> : <Loader/>}
        </div>
    )
}

export default LeaderboardPage;